import * as actionTypes from './actionTypes';

import type {
  ProfileAction,
} from '../types';

export const setProfileState = (
  keyOrRootValues: any,
  maybeValues?: any,
): ProfileAction => ({
  type: actionTypes.SET_PROFILE_STATE,
  payload: {
    keyOrRootValues,
    maybeValues,
  },
});

export const requestConnectProvider = (
  payload: number,
  provider: number,
) => ({
  type: actionTypes.REQUEST_CONNECT_PROVIDER,
  payload,
  provider,
});

export const requestFetchProfile = () => ({
  type: actionTypes.REQUEST_FETCH_PROFILE,
});

export const requestUpdateUser = ({
  body,
  userId,
  callbacks,
}: {
  body: any,
  userId?: number,
  callbacks?: any,
}) => ({
  type: actionTypes.REQUEST_UPDATE_USER,
  body,
  userId,
  callbacks,
});

export const requestUpdateSettings = ({
  body,
  clientId,
  settingsId,
  callbacks,
}: {
  body: any,
  clientId?: number,
  settingsId: number,
  callbacks?: any,
}) => ({
  type: actionTypes.REQUEST_UPDATE_SETTINGS,
  body,
  clientId,
  settingsId,
  callbacks,
});

export const requestMarkTutotialStepsComplite = ({
  steps,
  callbacks,
}: {
  steps: string[],
  callbacks?: any,
}) => ({
  type: actionTypes.REQUEST_MARK_TUTOTIAL_STEPS_COMPLITE,
  steps,
  callbacks,
});

export const requestFetchUserNamespace = ({
  namespaceSymbol,
}: {
  namespaceSymbol: string,
  callbacks?: any,
}): ProfileAction => ({
  type: actionTypes.REQUEST_USER_NAMESPACE,
  namespaceSymbol,
});
